import { Container, IntroContainer, MainContainer, ShareContainer } from "./ComponentCss";
import { useCallback, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import arrow_icon from "../_assets/images/arrow_icon.png";
import scroll_down_2 from "../_assets/images/scroll_down_2.png";

import down_icon from "../_assets/images/down_icon.png";
import { GrNext } from "react-icons/gr";

import twitter_img from "../_assets/images/twitter_img.png";
import fbook_img from "../_assets/images/fbook_img.png";
import insta_img from "../_assets/images/insta_img.png";
import kakao_img from "../_assets/images/kakao_img.png";
import link_img from "../_assets/images/link_img.png";

import { CopyToClipboard } from 'react-copy-to-clipboard';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';



export const DownloadSlider = () => {
    const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
    };
    return (
        <div className="share-img-cont mo">
            <Slider {...settings}>
            <div>
                <img src="https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/down_img1.f607ac98a6abe07bbc9b.jpg" alt="다운로드 이미지" />
                <a href="https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/down_img1.f607ac98a6abe07bbc9b.jpg" download="유니세프로_옳은답_알려주기.jpg" target="_blank" rel="noopener noreferrer" >
                    <img src={ down_icon } alt="다운로드 아이콘" />
                    다운받기
                </a>
            </div>
            <div>
                <img src="https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/down_img2.e598c4054f1b764c2105.jpg" alt="다운로드 이미지" />
                <a href="https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/down_img2.e598c4054f1b764c2105.jpg" download="유니세프로_옳은답_알려주기.jpg" target="_blank" rel="noopener noreferrer" >
                    <img src={ down_icon } alt="다운로드 아이콘" />
                    다운받기
                </a>
            </div>
            <div>
                <img src="https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/down_img3.26168fb88c6d7a56183d.jpg" alt="다운로드 이미지" />
                <a href="https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/down_img3.26168fb88c6d7a56183d.jpg" download="유니세프로_옳은답_알려주기.jpg" target="_blank" rel="noopener noreferrer" >
                <img src={ down_icon } alt="다운로드 아이콘" />
                    다운받기
                </a>
            </div>
            </Slider>
        </div>
    );
}

export const IntroComponent = () => {
    return (
        <MainContainer style={{ background: "#000", color: "#fff" }}>
            <IntroContainer>
                <div className="intro-tit">
                    <h1>유니세프 응답하기 캠페인</h1>
                    <p>
                        이 아이들에게 <br className="mo" />무슨일이 일어났을까요?
                    </p>
                </div>
                <div className="intro-img-cont">
                    <div className="intro-img1">
                        <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/intro_img1.b80bcceb58fce390b776.png" } alt="하마르 이미지" className="pc" />
                        <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/intro_img1_m.e192f787fc8361d8ed2e.png" } alt="하마르 이미지" className="mo" />
                        <p>
                            축구선수가 꿈이던 <br/><span>11살 하마르</span>와
                        </p>
                    </div>
                    <div className="intro-img2">
                        <p>
                            반에서 <br className="mo" />가장 공부를 잘했던 <br/><span>11살 밀락</span>
                        </p>
                        <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/intro_img2.9c77c14663461f75e861.png" } alt="밀락 이미지" className="pc" />
                        <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/intro_img2_m.f6bbfd529451b7868326.png" } alt="밀락 이미지" className="mo" />
                    </div>
                </div>
            </IntroContainer>
        </MainContainer>
    );
}
    export const ShareComponent = () => {

        useEffect(() => {
            window.Kakao.Share.createDefaultButton({
                container: '#kakaotalk-sharing-btn',
                objectType: 'feed',
                content: {
                    title: '꿈 많던 아이들에게 닥쳐온 비극',
                    description: '이 아이들은 당신의 응답을 기다리고 있습니다',
                    imageUrl:
                    'http://k.kakaocdn.net/dn/csfNTG/btrUi2wMrKC/D045qiPoLMjzYadhXTIwK1/kakaolink40_original.png',
                link: {
                    mobileWebUrl: 'https://www.unicef.or.kr/drtv/22unicef-asmr/',
                    webUrl: 'https://www.unicef.or.kr/drtv/22unicef-asmr/',
                    },
                },
                buttons: [
                    {
                        title: '사연 들어보기',
                        link: {
                            mobileWebUrl: 'https://www.unicef.or.kr/drtv/22unicef-asmr/',
                            webUrl: 'https://www.unicef.or.kr/drtv/22unicef-asmr/',
                        },
                    },
                ],
            });         
        }, []);

        return (
            <MainContainer style={{ background: "#00aeef", color: "#fff", height: "100vh", minHeight: "800px" }}>
                <ShareContainer>
                    <div className="share-img-cont pc">
                        <div>
                            <img src="https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/down_img1.f607ac98a6abe07bbc9b.jpg" alt="다운로드 이미지" />
                            <a href="https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/down_img1.f607ac98a6abe07bbc9b.jpg" download="유니세프로_옳은답_알려주기.jpg" target="_blank" rel="noopener noreferrer" >
                                <img src={ down_icon } alt="다운로드 아이콘" />
                                다운받기
                            </a>
                        </div>
                        <div>
                            <img src="https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/down_img2.e598c4054f1b764c2105.jpg" alt="다운로드 이미지" />
                            <a href="https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/down_img2.e598c4054f1b764c2105.jpg" download="유니세프로_옳은답_알려주기.jpg" target="_blank" rel="noopener noreferrer" >
                                <img src={ down_icon } alt="다운로드 아이콘" />
                                다운받기
                            </a>
                        </div>
                        <div>
                            <img src="https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/down_img3.26168fb88c6d7a56183d.jpg" alt="다운로드 이미지" />
                            <a href="https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/down_img3.26168fb88c6d7a56183d.jpg" download="유니세프로_옳은답_알려주기.jpg" target="_blank" rel="noopener noreferrer" >
                                <img src={ down_icon } alt="다운로드 아이콘" />
                                다운받기
                            </a>
                        </div>
                    </div>
                    <div className="mo share-slider-cont">
                        <DownloadSlider />
                    </div>
                    <p>버튼을 통해 위의 <br className="mo" />반전 문답 이미지를 다운로해 주세요.</p>
                    <p className="share-comm-bold">
                        다운로드한 이미지를 SNS에 공유하고<br />
                        아이들을 위한 유니세프의 응답하기를 <br className="mo" />널리 알려주세요.
                    </p>
                    <div className="share-btn-cont">
                        <button onClick={() => window.open('https://twitter.com/')}>
                            <img src={ twitter_img } alt="트위터 아이콘" />
                        </button>
                        <button onClick={() => window.open('https://ko-kr.facebook.com/')}>
                            <img src={ fbook_img } alt="페이스북 아이콘" />
                        </button>
                        <button onClick={() => window.open('https://www.instagram.com/')}>
                            <img src={ insta_img } alt="인스타그램 아이콘" />
                        </button>
                        <button id="kakaotalk-sharing-btn"  className="kakaoBtn" >
                            <img src={ kakao_img } alt="카카오톡 아이콘" />
                        </button>
                        <CopyToClipboard text={ 'https://www.unicef.or.kr/drtv/22unicef-asmr/' }>
                            <button onClick={() => alert('복사 되었습니다.') }>
                                <img src={ link_img } alt="링크 아이콘" />
                            </button>
                        </CopyToClipboard>
                        <span>공유하기<GrNext/></span>
                    </div>
                    <div className="scroll-txt pc">
                        SCROLL DOWN
                        <img src={ arrow_icon } alt="화살표 아이콘" />
                    </div>
                </ShareContainer>
            </MainContainer>
        );
}


export const WarCommonComponent = ({ warRef, warRef2, setBgIsBlack, playState, setSupportVisible }) => {
    const whiteBgRef = useRef();
    const startEleRef = useRef();
    const [wBgTop, setWBgTop] = useState();
    const [startEleTop, setStartEleTop] = useState();

    useEffect(() => {
        if (whiteBgRef !== undefined && ( startEleRef !== undefined || warRef !== undefined) && (playState === "war" || playState === "morning")) {
            setWBgTop(whiteBgRef.current.getBoundingClientRect().top + window.pageYOffset);
            setStartEleTop(warRef === null || warRef === undefined ? startEleRef.current.getBoundingClientRect().top + window.pageYOffset : warRef.current.getBoundingClientRect().top + window.pageYOffset);
            
        }
    }, [playState, warRef]);

    const scrollBGCheckHandler = useCallback(() => {
        if (playState === "war" || playState === "morning") {
            if (window.scrollY + 100 > wBgTop) setBgIsBlack(false);
            else setBgIsBlack(true);

            if (window.scrollY + 100 > wBgTop && window.scrollY + 100 < wBgTop + window.innerHeight - 200) {
                setSupportVisible(true);
            } else if (warRef2 !== undefined && window.scrollY + 100 > warRef2 && window.scrollY + 100 < warRef2 + window.innerHeight - 500) {
                setSupportVisible(true);
            } else if (window.scrollY < startEleTop - 500) {
                setSupportVisible( playState === "war" ? false : true);
            } else {
                setSupportVisible(false);
            }
        }
    }, [playState, setBgIsBlack, setSupportVisible, startEleTop, wBgTop, warRef2]);

    useEffect(() => {
        window.addEventListener("scroll", scrollBGCheckHandler);
        return () => {
        window.removeEventListener("scroll", scrollBGCheckHandler);
        };
    }, [scrollBGCheckHandler]);

    return (
        <>
            <Container className="p-4" ref={ warRef === null || warRef === undefined ? startEleRef : warRef}>
                <div className="comm" style={{ marginTop: "7rem" }}>
                    <div>
                        {
                            playState === "war" ? 
                            <p>
                                이 ASMR은 총격과 폭격으로 <br className="mo" />한순간에 무너진 집에서<br/>
                                빠져나오지 못한 하마르가 <br className="mo" />고통에 몸부림치는 소리입니다.
                            </p>
                            : 
                            <p className="not_asmr">
                            유니세프 응답하기 캠페인
                            </p>
                        }
                        <video controls>
                            <source src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_TVC.f0f4cbdb28e448a672be.mp4" } type="video/mp4" alt="전쟁 TVC" />
                        </video>
                    </div>
                    <button onClick={ () => window.open('https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E') } alt={ playState === "war" ? '하마르와 같은 아이들 도와주기' : '아이들의 목소리에 응답하기' }>
                        { playState === "war" ? '하마르와 같은 아이들 도와주기' : '아이들의 목소리에 응답하기' }
                    </button>
                </div>
            </Container>
            <Container className="p-5">
                <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_img1.98c75e0797dbe455298a.jpg" } className="pc" alt="전쟁 문제 이미지1" style={{ width: "36rem", marginTop: "1rem" }} />
                <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static//media/war_img1_m.98789287c827df4ae9cf.png" } className="mo" alt="전쟁 문제 이미지1" />
                <div className="comm">
                    <p className="comm-point">
                        “세계 최고의 스트라이커가 되고 싶었는데<br/>
                        이제 골키퍼 밖에 못해요”<br/>
                        <span>11살 하마르의 꿈을 앗아간 폭발</span>
                    </p>
                    <p className="comm-basic">
                        친구들 사이에서 득점왕으로 불리던 시리아의 11살 하마르는<br/>
                        어느 날 무장단체의 폭탄 테러 공격을 받았습니다.<br/>
                        그 끔찍한 테러로 하마르는 두 다리와 함께 <br className="mo" />축구의 꿈도 잃었습니다.
                    </p>
                    <button onClick={ () => window.open('https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E') } alt="하마르와 같은 아이들의 희망 되찾아주기">
                        하마르와 같은 아이들의 희망 되찾아주기
                    </button>
                </div>
                <span className="copyright">©UNICEF/ Syria 2021/ Hasan Bilal</span>
            </Container>
            <Container className="p-6">
                <div className="comm">
                    <p className="comm-point">
                        “저 때문에 엄마가 <br className="mo" />고생하는 것 같아서 슬퍼요”<br/>
                        <span>전쟁이 가져온 가난</span>
                    </p>
                    <p className="comm-basic">
                        그 때의 폭발로 하마르의 아버지는 돌아가셨고<br/>
                        어머니는 아이들을 먹여살리기 위해<br/>
                        먼 도시의 공장으로 일을 나갑니다.<br/>
                        그동안 하마르와 세 형제는 <br className="pc"/>
                        물에 빵을 적셔 먹으며 <br className="mo" />겨우 허기를 달랩니다.
                    </p>
                    <button onClick={ () => window.open('https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E') } alt="하마르와 같은 아이들에게 생계 지원하기">
                        하마르와 같은 아이들에게 생계 지원하기
                    </button>
                </div>
                <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static//media/war_img2.08e0ef8383e0bb93e192.jpg" } className="pc" alt="전쟁 문제 이미지2" style={{ paddingLeft: "3%", marginTop: ".5rem", width: "35.5rem" }} />
                <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static//media/war_img2_m.438c8056e5907ffef943.png" } className="mo" alt="전쟁 문제 이미지2" />
                <span className="copyright">©UNICEF/ Syria 2021/ Hasan Bilal</span>
            </Container>
            <Container className="p-7" ref={ whiteBgRef }>
                <div className="comm p-w-bg">
                    <p style={{ fontFamily: "AggroM,sans-serif", margin: "0" }}>
                        갑작스러운 폭격으로 찾아온 <br className="mo" />하마르의 절망에<br />
                    <span>유니세프가 응답</span> 했습니다
                    </p>
                </div>
                <img src={ scroll_down_2 } alt="scroll down 이미지2" className="scroll_img pc" style={{ width: "19rem" }} />
            </Container>
            <Container className="p-8">
                <div className="comm p-w-bg">                    
                    <p className="comm-tit">
                        “유니세프 덕분에 <br className="mo" />새 다리를 얻게 되었어요”
                    </p>
                    <p className="comm-point comm-point2">
                        하마르는 얼마 전 유니세프의 <br className="mo" />생계지원 프로그램을 통해<br className="pc"/>
                        새 의족을 맞추고 <br className="mo" />다시 새로운 꿈을 꾸게 되었습니다.
                    </p>
                    <p className="comm-basic">
                        유니세프, 95개국 취약계층 어린이 및 가정<br />
                        1억 3,300만명에게 지원 프로그램 진행 중
                    </p>
                    <button onClick={ () => window.open('https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E') } alt="유니세프 생계 지원 프로그램 동참하기">
                        유니세프 생계 지원 프로그램 동참하기
                    </button>
                </div>
            </Container>
        </>
    )
}

export const MarriageCommonComponent = ({ setBgIsBlack, marriRef, marriRef2, playState, setSpyEle, setSupportVisible }) => {
    const whiteBgRef = useRef();
    const startEleRef2 = useRef();
    const lastEleRef = useRef();
    const [wBgTop, setWBgTop] = useState();
    const [startEleTop, setStartEleTop] = useState();
    const [lastEleBottom, setLastEleBottom] = useState();

    useEffect(() => {       
        if (whiteBgRef !== undefined && ( startEleRef2 !== undefined || marriRef !== undefined) && (playState === "marriage" || playState === "birthday")) {
            setWBgTop(whiteBgRef.current.getBoundingClientRect().top + window.pageYOffset);
            setStartEleTop(marriRef === null || marriRef === undefined ? startEleRef2.current.getBoundingClientRect().top + window.pageYOffset : marriRef.current.getBoundingClientRect().top + window.pageYOffset);
        } else if (playState === "marriage" || playState === "") {
            setLastEleBottom(lastEleRef.current.getBoundingClientRect().bottom + window.pageYOffset);
        }
    }, [playState, startEleTop, marriRef]);

    const scrollBGCheckHandler = useCallback(() => {
        if (playState === "marriage" || playState === "birthday") {
            if (window.scrollY + 100 > wBgTop) setBgIsBlack(false);
            else setBgIsBlack(true);

            if (window.scrollY + 100 > wBgTop && window.scrollY + 100 < wBgTop + window.innerHeight - 600) {
                setSupportVisible(true);
            } else if (marriRef2 !== undefined && window.scrollY + 100 > marriRef2 && window.scrollY + 100 < marriRef2 + window.innerHeight - 600) {
                setSupportVisible(true);
            } else if (window.scrollY < startEleTop - 500) {
                setSupportVisible( playState === "marriage" ? false : true);
            } else if (playState === "marriage" && window.scrollY > lastEleBottom) {
                setBgIsBlack(true);
                setSpyEle('');
            }else {
                setSupportVisible(false);
            }
        } else if (playState === "" && window.scrollY > lastEleBottom) {
            setBgIsBlack(true);
        }
    }, [lastEleBottom, marriRef2, playState, setBgIsBlack, setSpyEle, setSupportVisible, startEleTop, wBgTop]);

    useEffect(() => {
        window.addEventListener("scroll", scrollBGCheckHandler);
        return () => {
        window.removeEventListener("scroll", scrollBGCheckHandler);
        };
    }, [scrollBGCheckHandler]);
    
    return (
        <>
            <Container className="p-4" style={{ background: `#000` }}  ref={ marriRef === null || marriRef === undefined ? startEleRef2 : marriRef }>
                <div className="comm">
                    <div>
                        {
                            playState === "marriage" ? 
                            <p>
                                이 ASMR은 조혼이라는 <br className="mo" />악습에 학대당하며<br/>
                                다신 고향으로 돌아올 수 없는 <br className="mo" />밀락의 울음 소리입니다.
                            </p>
                            : 
                            <p className="not_asmr">
                                유니세프 응답하기 캠페인
                            </p>
                        }
                        <video controls>
                            <source src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static//media/marriage_TVC.1a790fb319a88c0111c8.mp4" } type="video/mp4" alt="조혼 TVC" />
                        </video>
                    </div>
                    <button style={{ fontSize: "2.19rem" }} onClick={ () => window.open('https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E') } alt={ playState === "marriage" ? '밀락과 같은 아이들 도와주기' : '아이들의 목소리에 응답하기' }>
                    { playState === "marriage" ? '밀락과 같은 아이들 도와주기' : '아이들의 목소리에 응답하기' }
                    </button>
                </div>
            </Container>
            <Container className="p-5">
                <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static//media/marr_img1.b7b5ded0b848d9b18ae1.jpg" } className="pc" alt="조혼 문제 이미지1" style={{ width: "35.5rem", marginTop: "1rem" }} />
                <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static//media/marr_img1_m.58d5926a63b7f2d978de.png" } className="mo" alt="조혼 문제 이미지1" />
                <div className="comm">
                    <p className="comm-point">
                        “우리 집이 너무 가난해서…<br/>
                        어쩔 수 없이 결혼을 해야 돼요”<br/>

                        <span>자신의 의지와 상관없이 결혼하는 소녀들</span>
                    </p>
                    <p className="comm-basic">
                        11살 밀락은 집에 생활비를 지원받는 대가로<br/>
                        54살 남자와 결혼하게 되었습니다.<br/>
                        학교에서 그 누구보다 똑똑했던 밀락이지만<br/>
                        더 이상 학교에 갈 수도 친구들과 함께 놀 수도 없게 되었습니다.
                    </p>
                    <button onClick={ () => window.open('https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E') } alt="조혼의 위협에 빠진 아이들 구하기">
                        조혼의 위협에 빠진 아이들 구하기
                    </button>
                </div>               
                <span className="copyright">©UNICEF/ UN0227010</span>
            </Container>
            <Container className="p-6">
                <div className="comm">
                    <p className="comm-point">
                        “아내라면 제 아이를 낳아야죠”<br/>
                        <span style={{ fontSize: "inherit" }}>이른 출산의 위협에 놓인 소녀들</span>
                    </p>
                    <p className="comm-basic">
                        얼마 전 밀락은 남편의 강요에 못 이겨 <br />출산까지 하게 되었습니다.<br/>
                        출산 과정에서 밀락은 심각한 산고뿐만 아니라<br/>
                        자궁 탈출증 등의 임신 후유증에도 시달렸습니다.
                    </p>
                    <button onClick={ () => window.open('https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E') } alt="밀락을 출산의 위협에서 구하기">
                        밀락을 출산의 위협에서 구하기
                    </button>
                </div>
                <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static//media/marr_img2.65c04484497a5c247a66.jpg" } className="pc" alt="조혼 문제 이미지2" style={{ paddingLeft: "3%", width: "35rem" }} />
                <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static//media/marr_img2_m.29ba33ca277330aefe40.png" } className="mo" style={{ width: "95%", marginLeft: "5%" }} alt="조혼 문제 이미지2" />               
                <span className="copyright">©UNICEF/ UN0227010</span>
            </Container>
            <Container className="p-7" ref={ whiteBgRef }>
                <div className="comm p-w-bg">
                    <p style={{ fontFamily: "AggroM,sans-serif", margin: "0" }}>
                        조혼의 악습에 학대당하던 <br className="mo" />밀락의 울음에<br />
                        <span>유니세프가 응답</span> 했습니다
                    </p>
                </div>
                <img src={ scroll_down_2 } alt="scroll down 이미지2" className="scroll_img" style={{ width: "19rem" }} />
            </Container>
            <Container className="p-8" ref={ lastEleRef }>
                <div className="comm p-w-bg">
                    <p className="comm-tit">
                        “유니세프 덕분에 다시 <br className="mo" />제 꿈을 되찾을 수 있게 되었어요”
                    </p>
                    <p className="comm-point comm-point2">
                        유니세프 지역 상담소는<br className="pc" />
                        밀락이 다시 <br className="mo" />어린이답게 살 수 있는 지원을 시작했습니다.<br/>
                        덕분에 그렇게 원하던 <br className="mo" />학교와 집으로 돌아갈 수 있게 된<br/>
                        밀락의 얼굴에는 다시 웃음꽃이 피었습니다.

                    </p>
                    <p className="comm-basic">
                        지역 정부와 연계한 유니세프 조혼 방지 프로그램 운영<br />
                        관계 당국에 정책 제안, 조혼 인식 개선 교육 사업 진행
                    </p>
                    <button onClick={ () => window.open('https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E') } alt="악습에서 아이들 구해주기">
                        악습에서 아이들 구해주기
                    </button>
                </div>
            </Container>
        </>
    );
};
